import { Contact } from "lucide-react";
import React, { useState, useEffect } from "react";
import ContactHero from "./ContactHero";
import ContactForm from "./ContactForm";

export default function Home() {
  return (
    <div>
        <ContactHero />
        <ContactForm />
    </div>
  );
}
